import React from 'react'
import JoinMemberComp from '../../../components/main/login/joinmember/JoinMemberComp'


export const JoinMember = () => {
  return (
    <div>
      <JoinMemberComp/>
    </div>
  )
}
